import $ from 'jquery';
import '../vendor/dotimeout/jquery.ba-dotimeout.min';

const endpoint = 'https://www.rcsdk8.org/rcsd/feed/alert';
const keyPrefix = 'has_seen_district_alert';

export default class DistrictAlert {
  constructor(element) {
    this.$element = $(element);
    this.$instance = null;
    // Set context
    this.done = this.done.bind(this);
    this.click = this.click.bind(this);
    // Fire off request
    this.request = $.ajax(this.settings);
    this.request.done(this.done);
  }

  done(response) {
    this.response = response;
    if (this.response.title && this.response.nid && !this.seen) {
      this.instance = this.response;
      this.appendBlock();
      this.listen();
      this.show();
    }
  }

  appendBlock() {
    this.$element.find('.page').before(this.$instance);
  }

  click(event) {
    this.seen = true;
    event.stopPropagation();

    // Close out alert if the node wasn't clicked on.
    if ($(event.target).is('.block, .dismiss')) {
      event.preventDefault();
      this.hide();
    }
  }

  show() {
    this.$instance.doTimeout('show', 500, () => {
      this.$instance.addClass('show');
    });
  }

  hide() {
    this.$instance.removeClass('show');
  }

  listen() {
    this.$instance.on('click', this.click);
  }

  get key() {
    return `${keyPrefix}_${this.response.nid}`;
  }

  get seen() {
    return sessionStorage.getItem(this.key) || false;
  }

  set seen(status) {
    sessionStorage.setItem(this.key, status);
  }

  set instance(data) {
    // Block template
    const template = `
      <div class="district-alert block">
        <div class="block-inner">
          <article class="node">
            <div class="node-inner">
              <div class="node-header">
                <a href="${data.destination}" title="${data.title}" target="_blank">
                  <span class="title">${data.title}</span>
                </a>
              </div>
              <div class="node-links">
                <button class="dismiss">Dismiss</button>
              </div>
            </div>
          </article>
        </div>
      </div>
    `;

    // Create our block of content.
    this.$instance = $(template);

    // Add subtitle, if applicable
    if (data.subtitle.length) {
      const subtitle = `<br class="accessible-break"><span class="subtitle">${data.subtitle}</span>`;
      this.$instance.find('.node-header a').append(subtitle);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  get settings() {
    return {
      url: endpoint,
      cache: false,
      method: 'get',
      dataType: 'json',
    };
  }
}



// WEBPACK FOOTER //
// ./DistrictAlert.js